import { IAllCenterContactList } from '@nkr/models/all-centers';
import { Table } from 'react-bootstrap';

interface IProps {
    centerData: IAllCenterContactList[]
}

const Grid = (props: IProps) => {
    return (
        <Table bordered striped condensed className='table-nkr-styled'>
            <thead>
                <tr>
                    <th style={{ textAlign: 'center', backgroundColor: '#337ab7', color: 'white' }}>R #</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#337ab7', color: 'white' }}>Name</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#337ab7', color: 'white' }}>Position(s)</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#337ab7', color: 'white' }}>E-mail</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#337ab7', color: 'white' }}>Phone Number(s)</th>
                </tr>
            </thead>
            <tbody>
                {props.centerData != null && props.centerData.map((x, i) => {
                    let positions = x.positions.map(x => x.position);
                    
                    return (
                        <tr key={i}>
                            <td style={{ textAlign: 'center' }}>{i + 1}</td>
                            <td style={{ textAlign: 'center' }}>{x.title}</td>
                            <td style={{ textAlign: 'center' }}>{positions.join(', ')}</td>
                            <td style={{ textAlign: 'center' }}>{x.email}</td>
                            <td style={{ textAlign: 'center' }}>{x.phoneNumbers.join(' ')}</td>
                        </tr>
                    )}
                )}
            </tbody>
        </Table>
    );
}

export default Grid;